/**
 * Shows or hides the Pylon chat bubble (the floating button).
 */
export function togglePylonBubble(show: boolean): void {
  if (typeof window.Pylon !== 'function') return
  window.Pylon('setBubbleVisibility', show)
}

/**
 * Shows or hides the full Pylon chat panel.
 */
export function togglePylonChat(show: boolean): void {
  if (typeof window.Pylon !== 'function') return
  window.Pylon(show ? 'show' : 'hide')
}
